var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { ajaxSend } from 'api/api';
import { conversationsOverviewActions } from '../actions/conversationsOverview';
import { getConversationBulkIDs, getConversationBulkIDsByCSIDs, getConversationMessages, } from '../api/conversationsOverview';
const { conversationsOverviewGetMessages, conversationsOverviewGetMessagesSucceeded, conversationsOverviewGetMessagesFailed, conversationsOverviewFetchBulkIds, conversationsOverviewFetchBulkIdsSucceeded, conversationsOverviewFetchBulkIdsFailed, conversationsOverviewFetchBulkIdsSave, } = conversationsOverviewActions;
export const conversationsOverview = [
    takeLatest(conversationsOverviewGetMessages.toString(), genWithPromise(getConversationMessages, conversationsOverviewGetMessagesSucceeded, conversationsOverviewGetMessagesFailed)),
    takeLatest(conversationsOverviewFetchBulkIds.toString(), genWithPromise((payload) => {
        if (payload.useSearchAPI) {
            const { sort, page } = payload, data = __rest(payload, ["sort", "page"]);
            return ajaxSend({
                path: `/v3/search/advanced/bulk/ids`,
                method: 'POST',
                data,
            });
        }
        if (Array.isArray(payload.csids)) {
            return getConversationBulkIDsByCSIDs(payload);
        }
        return getConversationBulkIDs(payload);
    }, conversationsOverviewFetchBulkIdsSucceeded, conversationsOverviewFetchBulkIdsFailed)),
    takeEvery(conversationsOverviewFetchBulkIdsSucceeded.toString(), genConversationOverviewSaveBulkIds()),
];
function genWithPromise(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(resultFailedAction(result));
        }
    };
}
function genConversationOverviewSaveBulkIds() {
    return function* (action) {
        yield put(conversationsOverviewFetchBulkIdsSave(Object.assign(Object.assign({}, action.payload), { queryFilter: location.search })));
    };
}
